/**
 * useRoster.ts
 * Subscribes to the Firestore class roster and syncs to the class store.
 */

import { useEffect } from 'react';
import { subscribeToRoster } from '@db/studentService';
import { useClassStore } from '@store/classStore';

export function useRoster(classId: string | null): void {
  const setRoster = useClassStore((s) => s.setRoster);

  useEffect(() => {
    if (!classId) {
      setRoster([]);
      return;
    }

    const unsubscribe = subscribeToRoster(classId, (students) => {
      setRoster(students);
    });

    return unsubscribe;
  }, [classId, setRoster]);
}
